/** Что открыть в шторке кошелька (виджет брокера). */
export interface WalletRequest {
  mode: 'deposit' | 'withdraw';
  /** Пакет токенов, ради которого открыли пополнение. */
  packageId?: string;
  /** С какого экрана пришли — для аналитики воронки. */
  stage?: string;
}

export type DeepLinkTab = 'home' | 'trade' | 'terminal' | 'tokens' | 'account';

/**
 * Deep-link из бота: бот не умеет показать iframe, поэтому кнопки «Пополнить» /
 * «Вывести» / пакет токенов открывают Mini App сразу на нужном экране.
 * Формат: `?go=wallet:deposit`, `?go=wallet:withdraw`, `?go=tokens:<packageId>`, `?go=<tab>`, плюс `&st=<экран воронки>`
 * (то же понимаем и в hash). Telegram дописывает свои параметры в hash через `&`.
 */
export function parseDeepLink(hash: string, search: string): { tab?: DeepLinkTab; wallet?: WalletRequest } {
  const read = (source: string, key: string): string | null =>
    new URLSearchParams(source.replace(/^[#?]/, '')).get(key);
  const go = read(hash, 'go') ?? read(search, 'go');
  if (!go) return {};
  // с какого экрана воронки бот открыл приложение — уедет в аналитику при выпуске сессии виджета
  const from = (read(hash, 'st') ?? read(search, 'st') ?? '').slice(0, 64);
  const [head = '', tail = ''] = go.split(':');
  if (head === 'wallet' && (tail === 'deposit' || tail === 'withdraw')) {
    return { tab: 'account', wallet: { mode: tail, stage: from || 'bot' } };
  }
  if (head === 'tokens') {
    return tail
      ? { tab: 'tokens', wallet: { mode: 'deposit', packageId: tail, stage: from || `tokens:${tail}` } }
      : { tab: 'tokens' };
  }
  if (head === 'home' || head === 'trade' || head === 'terminal' || head === 'account') return { tab: head };
  return {};
}
